import Animations from './modules/Animations'
import Accordions from './modules/Accordions'
// import ContactForm from './modules/ContactForm'
// import FloatingButton from './modules/FloatingButton'
import FlipCards from './modules/FlipCards'
import Menu from './modules/Menu'
import Quiz from './modules/Quiz'
import ScrollRows from './modules/ScrollRows'
import Sliders from './modules/Sliders'
// import Tabs from './modules/Tabs'
import TimelineModal from './modules/TimelineModal'

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    Menu.init()
    Accordions.init()
    // ContactForm.init()
    // FloatingButton.init()
    Sliders.init()
    FlipCards.init()
    Quiz.init()
    // Tabs.init()
    TimelineModal.init()
    window.addEventListener('load', () => {
      Animations.init()
      ScrollRows.init()
    })
  }
}

const main = new Main()
